import { render, staticRenderFns } from "./ProjectAlertBlock.vue?vue&type=template&id=669599cc&"
import script from "./ProjectAlertBlock.vue?vue&type=script&lang=js&"
export * from "./ProjectAlertBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports